import React, { useState, useRef, useEffect } from "react";
import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";

// primereact components
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { Skeleton } from "primereact/skeleton";

// gif

import Success from "../../../../assets/success/succesConect.gif";
// context
import { useAiRegi } from "../Context/AiRegiContext";

// services
import { getConnectionQuick } from "../../../../services/QuickRegister/getConnectionQuick";
import { deleteConnectionQuick } from "../../../../services/QuickRegister/deleteConnectQuick";

const ConnectAI = ({ onReload, connected: connectedProp, loading }) => {
  const { settingsAI } = useAiRegi();
  const [loadingSession, setLoadingSession] = useState(false);
  const [sameIdCount, setSameIdCount] = useState(0);
  const [showReconnectButton, setShowReconnectButton] = useState(false);
  const lastQrIdRef = useRef(null);
  // const isApiMode = settingsAI?.iaModuleType === 'qr';

  const {
    data: connectionData,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["connectionQuick"],
    queryFn: getConnectionQuick,
    refetchInterval: 10000,
  });
  const isConnected = connectionData?.status === 1 || connectedProp;

  // Efeito para verificar se o QR code ID se repetiu 6 vezes
  useEffect(() => {
    if (connectionData?.qrcode && !isConnected && !isLoading) {
      const currentQrId = connectionData.id || connectionData.qrcode;

      if (lastQrIdRef.current === null) {
        // Primeira vez, apenas armazena o ID
        lastQrIdRef.current = currentQrId;
        setSameIdCount(1);
        setShowReconnectButton(false);
      } else if (lastQrIdRef.current === currentQrId) {
        setSameIdCount((prev) => {
          const newCount = prev + 1;
          // Só mostra o botão se já passou um tempo razoável (6 queries = 1 minuto)
          if (newCount >= 6) {
            setShowReconnectButton(true);
          }
          return newCount;
        });
      } else {
        // QR code mudou, reset
        setSameIdCount(1);
        setShowReconnectButton(false);
        lastQrIdRef.current = currentQrId;
      }
    } else if (isConnected) {
      // Reset quando conectado
      setSameIdCount(0);
      setShowReconnectButton(false);
      lastQrIdRef.current = null;
    } else if (!connectionData?.qrcode) {
      setSameIdCount(0);
      setShowReconnectButton(false);
    }
  }, [connectionData, isConnected, isLoading]);

  const handleGetConnection = async () => {
    try {
      setLoadingSession(true);
      const data = await getConnectionQuick();
      setLoadingSession(false);
      return data;
    } catch (error) {
      setLoadingSession(false);
      console.error("Error fetching connection data:", error);
      throw error;
    }
  };

  const mutationDisconnect = useMutation(deleteConnectionQuick, {
    onMutate: () => {
      mutationDisconnect.toastId = toast.loading("Desconectando...");
    },
    onSuccess: () => {
      toast.update(mutationDisconnect.toastId, {
        render: "Desconectado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
      if (typeof onReload === "function") onReload();
      refetch();
    },
    onError: () => {
      toast.update(mutationDisconnect.toastId, {
        render: "Erro ao desconectar.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    },
  });
  const handleDisconnect = () => {
    mutationDisconnect.mutate();
    // Reset dos estados quando desconectar
    setSameIdCount(0);
    setShowReconnectButton(false);
    lastQrIdRef.current = null;
  };

  const handleReconnect = () => {
    // Reset e força nova busca
    setSameIdCount(0);
    setShowReconnectButton(false);
    lastQrIdRef.current = null;
    refetch();
    mutationDisconnect.mutate();
  };

  return (
    <div style={{ padding: 24 }}>
      {!isConnected ? (
        <div className="row">
          <div className="col-12 col-xl-6 d-flex flex-column justify-content-center mx-auto order-1 order-md-1">
            <h1
              style={{
                fontSize: 32,
                marginBottom: 18,
                textAlign: "left",
                fontWeight: 700,
              }}
              className="mb-5"
            >
              Conectar à IA de cadastro Rápido
            </h1>
            <ol style={{ fontSize: 18, marginLeft: 16, marginBottom: 10 }}>
              <li style={{ marginBottom: 10 }}>
                Abra o app do WhatsApp no seu celular.
              </li>
              <li style={{ marginBottom: 10 }}>
                Toque em <strong>Mais opções</strong> ou{" "}
                <strong>Configurações</strong>.
              </li>
              <li style={{ marginBottom: 10 }}>
                Toque em <strong>Dispositivos conectados</strong> e depois em{" "}
                <strong>Conectar dispositivo</strong>.
              </li>
              <li style={{ marginBottom: 10 }}>
                Aponte seu celular para escanear o QR code.
              </li>
            </ol>
          </div>
          <div
            className="col-12 col-xl-6 d-flex flex-column justify-content-center align-items-center order-2 order-md-3"
            style={{ minHeight: 140 }}
          >
            {showReconnectButton ? (
              <div
                style={{
                  width: 250,
                  height: 250,
                  backgroundColor: "#f8f9fa",
                  border: "2px dashed #dee2e6",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                }}
              >
                <i
                  className="pi pi-refresh"
                  style={{
                    fontSize: 48,
                    color: "#6c757d",
                    marginBottom: 16,
                  }}
                ></i>
                <Button
                  label="Reconectar"
                  icon="pi pi-refresh"
                  onClick={handleReconnect}
                  severity="warning"
                  size="small"
                  className="p-button-raised"
                  loading={mutationDisconnect.isLoading}
                />
                <p
                  style={{
                    fontSize: 12,
                    color: "#6c757d",
                    marginTop: 12,
                    marginBottom: 0,
                    maxWidth: 200,
                  }}
                >
                  QR Code não está atualizando. Clique para reconectar.
                </p>
              </div>
            ) : connectionData?.qrcode !== null && connectionData?.qrcode ? (
              <>
                <Image
                  src={`data:image/png;base64,${connectionData.qrcode}`}
                  alt="QR Code"
                  width="250"
                />
              </>
            ) : (
              <>
                <Skeleton size="15rem" borderRadius="8px" />
              </>
            )}
          </div>
          {/* <Button
                icon={
                  mutationDisconnect.isLoading
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-times"
                }
                label={
                  mutationDisconnect.isLoading
                    ? "Desconectando..."
                    : "Desconectar"
                }
                onClick={handleDisconnect}
                severity="danger"
                size="small"
                style={{ marginTop: 18 }}
                disabled={mutationDisconnect.isLoading}
              /> */}
        </div>
      ) : (
        <div className="row">
          <div className="col-12 col-md-6 d-flex flex-column justify-content-center mx-auto order-1 order-md-1">
            <h1
              style={{
                fontSize: 32,
                marginBottom: 18,

                fontWeight: 700,
              }}
              className="mb-5 text-success"
            >
              Conectado à IA de cadastro Rápido
            </h1>
            <div style={{ fontSize: 18, marginLeft: 16, marginBottom: 10 }}>
              <h2
                style={{
                  fontSize: 22,
                  fontWeight: 700,
                  marginBottom: 10,
                }}
                className="mb-3"
              >
                Seu celular foi conectado!
              </h2>
              <p style={{ fontSize: 16 }} className="text-muted">
                Agora você pode usar a IA de cadastro rápido normalmente pelo
                WhatsApp.
                <br />
                Caso queira desconectar, clique no botão abaixo.
              </p>
              <Button
                icon={
                  mutationDisconnect.isLoading
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-times"
                }
                label={
                  mutationDisconnect.isLoading
                    ? "Desconectando..."
                    : "Desconectar"
                }
                onClick={handleDisconnect}
                severity="danger"
                size="small"
                style={{ marginTop: 18 }}
                disabled={mutationDisconnect.isLoading}
              />
            </div>
          </div>
          <div
            className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center order-2 order-md-2"
            style={{ minHeight: 140 }}
          >
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  width: 120,
                  height: 120,
                  backgroundColor: "#28a745",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 15,
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              >
                <i
                  className="fa fa-check"
                  style={{ fontSize: 60, color: "white" }}
                ></i>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConnectAI;
